// ElderRay.js
import * as d3 from 'd3';
import theme from '../../theme';

export const drawElderRay = (svg, data, xScale, yScale, values) => {
    if (!values?.bull_power || !values?.bear_power) return;

    const bullPoints = values.bull_power.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const bearPoints = values.bear_power.map((value, i) => ({
        x: new Date(data[i]?.start_date),
        y: value
    })).filter(d => !isNaN(d.y) && d.y !== null);

    const lineGenerator = d3.line()
        .x(d => xScale(d.x))
        .y(d => yScale(d.y))
        .curve(d3.curveMonotoneX);

    // Bull Power (green)
    svg.append('path')
        .datum(bullPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.elderRay.bull)
        .attr('stroke-width', 2)
        .attr('d', lineGenerator);

    // Bear Power (red)
    svg.append('path')
        .datum(bearPoints)
        .attr('fill', 'none')
        .attr('stroke', theme.indicators.elderRay.bear)
        .attr('stroke-width', 2)
        .attr('d', lineGenerator);

    // Create histogram-style bars for better visualization
    const barWidth = Math.max(1, (xScale.range()[1] - xScale.range()[0]) / Math.max(bullPoints.length, bearPoints.length) * 0.8);

    // Bull Power bars
    svg.selectAll('.bull-bar')
        .data(bullPoints)
        .enter()
        .append('rect')
        .attr('class', 'bull-bar')
        .attr('x', d => xScale(d.x) - barWidth / 2)
        .attr('y', d => d.y >= 0 ? yScale(d.y) : yScale(0))
        .attr('width', barWidth)
        .attr('height', d => Math.abs(yScale(d.y) - yScale(0)))
        .attr('fill', theme.indicators.elderRay.bull)
        .attr('opacity', 0.6);

    // Bear Power bars
    svg.selectAll('.bear-bar')
        .data(bearPoints)
        .enter()
        .append('rect')
        .attr('class', 'bear-bar')
        .attr('x', d => xScale(d.x) - barWidth / 2)
        .attr('y', d => d.y >= 0 ? yScale(d.y) : yScale(0))
        .attr('width', barWidth)
        .attr('height', d => Math.abs(yScale(d.y) - yScale(0)))
        .attr('fill', theme.indicators.elderRay.bear)
        .attr('opacity', 0.6);
};